import * as Yup from "yup";
import { differenceInMinutes } from "date-fns";
import { isQuarterHour } from "@hubcapp/components/Calendar/components/Modals/ViewLessonModal/utils";

type LessonFormSchema = {
  startDateTime: Date;
  endDateTime: Date;
  travelTime: number;
  test: boolean;
};

export const validationSchema: Yup.SchemaOf<LessonFormSchema> = Yup.object()
  .shape({
    startDateTime: Yup.date()
      .typeError("Please enter a valid start time")
      .test(
        "is-quarter-hour",
        "Start time must be to the nearest quarter of an hour",
        isQuarterHour,
      )
      .test(
        "times-are-successive",
        "Start time should be before end time",
        (startDateTime: Date | undefined, context: any) =>
          Boolean(startDateTime) &&
          differenceInMinutes(
            context.parent.endDateTime,
            startDateTime as Date,
          ) > 0,
      )
      .required("Start time required"),
    endDateTime: Yup.date()
      .typeError("Please enter a valid end time")
      .required("End time required")
      .test(
        "is-quarter-hour",
        "End time must be to the nearest quarter of an hour",
        isQuarterHour,
      )
      .test(
        "times-are-successive",
        "End time should not be before start time",
        (endTime: Date | undefined, context: any) =>
          Boolean(endTime) &&
          differenceInMinutes(endTime as Date, context.parent.startDateTime) >
            0,
      )
      .test(
        "times-gap",
        "The minimum lesson length is 60 minutes",
        (endTime: Date | undefined, context: any) =>
          Boolean(endTime) &&
          differenceInMinutes(endTime as Date, context.parent.startDateTime) >=
            60,
      ),
    travelTime: Yup.number(),
    test: Yup.boolean(),
  })
  .defined();
